<!-- @if(globals.showsplash) {
<app-full-loader></app-full-loader>
} -->

<router-outlet />
